import { render, staticRenderFns } from "./SToolbar.vue?vue&type=template&id=0146980c&"
import script from "./SToolbar.vue?vue&type=script&lang=js&"
export * from "./SToolbar.vue?vue&type=script&lang=js&"
import style0 from "./SToolbar.vue?vue&type=style&index=0&id=0146980c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports